const brandName = 'Seede';

export function renderLogo(renderContext, node) {
  const { context } = renderContext;

  const cardW = node.w;
  const cardH = node.h;
  const margin = 20;
  const radius = 6; // 圆角半径
  const logoH = 28;
  const logoW = 76;
  const logoX = cardW - logoW - margin; // 右下角 x 坐标
  const logoY = cardH - logoH - margin; // 右下角 y 坐标

  context.fillStyle = '#ffffff'; // 白色填充
  context.beginPath();
  context.roundRect(logoX, logoY, logoW, logoH, radius);
  context.closePath();
  context.fill();

  const logoSize = 22;
  const padding = (logoH - logoSize) / 2;

  if (renderContext.logoCache.img) {
    context.drawImage(
      renderContext.logoCache.img,
      logoX + padding,
      logoY + padding,
      logoSize,
      logoSize
    );
  }

  const fontSize = 14;
  const lineHeight = fontSize * 1.25;
  context.font = `bold ${fontSize}px Poppins`; // 设置字体
  context.fillStyle = '#333'; // 设置文字颜色
  context.textAlign = 'left'; // 设置文字对齐方式
  context.textBaseline = 'middle'; // 设置文字基线
  context.fillText(
    brandName,
    logoX + padding * 2 + logoSize,
    logoY + logoH / 2 + (lineHeight - fontSize) / 2
  );
}

export function renderGeneratedBy(renderContext) {
  const { context } = renderContext;
  const card = renderContext.card;
  const cardW = card.props.w;
  const cardH = card.props.h;
  const margin = 0.5 * card.props.padding;
  const fontSize = Math.round(card.props.padding * 0.4);
  const text = `Generated by ${brandName}`;

  context.font = `${fontSize}px Poppins`; // 设置字体
  context.fillStyle = 'rgba(255, 255, 255, 0.3)'; // 设置文字颜色
  context.textAlign = 'center'; // 设置文字对齐方式
  context.textBaseline = 'middle'; // 设置文字基线

  const textX = cardW / 2; // 居中 x 坐标
  const textY = cardH - margin; // 底部 y 坐标

  context.fillText(text, textX, textY);
}
